/**
 * Domain configuration — single source of truth.
 *
 * 与 coverfy-web 对称：
 *   - 大后台登录 = admin.coverfy.ai（不是 console.coverfy.ai —— 该域无 DNS/nginx）
 *   - 客户站 = coverfy.ai
 *   - 替换新域名时，只改 VITE_COVERFY_SITE_URL / VITE_CONSOLE_URL 这两个变量。
 */

const env = import.meta.env || {};

export const COVERFY_SITE_URL = env.VITE_COVERFY_SITE_URL || 'https://coverfy.ai';
export const CONSOLE_URL = env.VITE_CONSOLE_URL || 'https://admin.coverfy.ai';
export const BFF_URL = env.VITE_BFF_URL || '';

/* 客户站配套链接 */
export const coverfyLinks = {
  home: COVERFY_SITE_URL,
  register: `${COVERFY_SITE_URL}/register`,
  preview: `${COVERFY_SITE_URL}/protect/analyze`
};

export const consoleLinks = {
  login: `${CONSOLE_URL}/login`,
  console: CONSOLE_URL
};
